import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';

import { AuthenticationService } from '../../authentication/authentication.service';
import { AuthUser } from '../../authentication/authentication.interfaces';
import { translations } from 'src/i18n/translations';
import { SharedService } from '../../services/shared.service';
import { errors } from 'src/app/shared/helpers/errors';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  backupToken: boolean;
  formSubmitAttempt: boolean;
  loginForm = this.fb.group({
    username: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
    otpToken: ['', Validators.required]
  });
  otpRequired: string;
  otpToken: AbstractControl;
  password: AbstractControl;
  username: AbstractControl;

  constructor(private authenticationService: AuthenticationService, private fb: FormBuilder, private sharedService: SharedService) {
  }

  ngOnInit(): void {
    this.username = this.loginForm.get('username');
    this.password = this.loginForm.get('password');
    this.otpToken = this.loginForm.get('otpToken');
    this.loginForm.controls.otpToken.disable();
  }

  loginErrorHandler(response: HttpErrorResponse): void {
    if (response.error.OTP === 'required') {
      this.loginForm.controls.otpToken.enable();
      this.formSubmitAttempt = false;
      this.otpRequired = response.error.method;
    } else if (response.error.detail) {
      this.sharedService.showError(errors[response.error.detail][this.sharedService.language]);
      if (response.error.detail === 'Failed to generate code.') {
        this.otpRequired = 'BACKUP';
      }
    } else {
      throw response;
    }
  }

  onSubmit(): void {
    this.formSubmitAttempt = true;

    if (this.loginForm.valid) {
      const user: AuthUser = {
        username: this.username.value,
        password: this.password.value,
        token: this.backupToken ? '' : this.otpToken.value,
        backup_token: this.backupToken ? this.otpToken.value : ''
      };

      this.authenticationService.login(user).subscribe({
        next: (value) => {
          if (value === null) {
            this.authenticationService.removeCookies();
            this.sharedService.showError(translations[this.sharedService.language].permissionError);
          }
        },
        error: (response: HttpErrorResponse) => this.loginErrorHandler(response)
      });
    }
  }

  backendUrl = environment.baseUrl.replace('/api/deck/', '/backend/deck-redirect');

  useBackupToken(): void {
    this.backupToken = true;
  }
}
